var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":"扫码下载APP","mask-closable":false,"footer-hide":""},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('img',{staticClass:"qr-code",attrs:{"src":require("@/assets/QRcode.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }